import React from 'react';

interface MinimalLoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /**
   * Variante colore:
   * - 'default': arco nero (uso generico, neutro)
   * - 'brand': arco Flusia rosa (#E91E8C) per loader feature-page
   */
  variant?: 'default' | 'brand';
  className?: string;
}

export function MinimalLoader({ size = 'md', variant = 'default', className = '' }: MinimalLoaderProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
    xl: 'h-12 w-12'
  };
  const arcColor = variant === 'brand'
    ? 'border-[#E91E8C] border-t-transparent'
    : 'border-black dark:border-white border-t-transparent';
  const trackColor = variant === 'brand'
    ? 'border-[#E91E8C]/15'
    : 'border-black/10 dark:border-white/10';

  return (
    <div className={`${sizeClasses[size]} ${className} relative`}>
      <div className={`absolute inset-0 rounded-full border-2 ${trackColor}`}></div>
      <div className={`absolute inset-0 rounded-full border-2 ${arcColor} animate-spin`}></div>
    </div>
  );
}

export function MinimalLoaderInline({ size = 'sm', className = '' }: MinimalLoaderProps) {
  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4', 
    lg: 'h-5 w-5'
  };

  return (
    <div className={`${sizeClasses[size]} ${className} relative inline-block`}>
      <div className="absolute inset-0 rounded-full border border-black/10"></div>
      <div className="absolute inset-0 rounded-full border border-black border-t-transparent animate-spin"></div>
    </div>
  );
}